<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-11 16:16:45
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-05-08 10:58:51
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/poster/trendPoster.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
	<div>
		<div class="box_4 flex-col" v-if="detail.type == 'PICTURE' || detail.type == 'PEOPLE_HOMEPAGE' || detail.type == 'FORWARDING' || detail.type == 'ENTERPRISES'  || detail.type == 'NEWS'">
			<div class="block_1 flex-row">
				<img class="label_2" referrerpolicy="no-referrer" :src="detail.avatar" />
				<div class="text-wrapper_3 flex-col justify-between">
					<div class="text_2">{{ detail.contactName }}</div>
					<div class="text_3 text-ellipsis-2">{{ detail.company }}·{{ detail.position }}</div>
				</div>
			</div>
			<div class="text_5 text-ellipsis-1">
				<div class="inline-important">
					<div class="inline-important topic" @click.stop="handelTopic()" v-if="detail.topicName">#{{ detail.topicName }}</div>
					{{ detail.content }}
				</div>
				<div v-if="detail.userPublishForwardingVo && detail.userPublishForwardingVo.userPublishForwardingRefVoList.length > 1" class="inline-important">
					<div class="inline-important" v-for="(item, index) in detail.userPublishForwardingVo.userPublishForwardingRefVoList">
						<div class="inline-important" :key="index" v-if="index != 0">
							//
							<div class="inline-important contactName" @click.stop="handelUserMainPage(item)">@{{ item.contactName }}</div>
							:
							<div class="inline-important topic" v-if="item.topicName" @click.stop="handelTopic(item)">#{{ item.topicName }}</div>
							<div class="inline-important content">{{ item.content }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="image-wrapper_2 flex-row" v-if="detail.type == 'PICTURE'">
				<div class="pictureBox" v-for="(item, index) in detail.userPublishAttachmentVos">
					<img class="image_1-0" referrerpolicy="no-referrer" :src="item.previewUrl" v-if="item.fileType == 1" />
					<div class="image_1-0" v-else>
						<video class="image_1-0" referrerpolicy="no-referrer" :src="item.previewUrl" initial-time="0.01"  style="object-fit: cover;"/>
						<div class="dialog">
							<img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/play.png" alt="" style="width: 40px; height: 40px" />
						</div>
					</div>
					<div class="dialog" v-if="detail.pictureLength > 3 && index == 2">+{{ detail.pictureLength - 3 }}</div>
				</div>
			</div>

			<!-- <div class="image-wrapper_2 flex-row" v-if="detail.type == 'EXHIBITION'">
        <img class="image_exhibition" alt="" :src='detail.userPublishLinkVos[0].coverUrl'>
      </div> -->

			<!-- <div class="image-wrapper_2 flex-row" v-if="detail.type == 'HOLD_MEETING'">
        <img class="image_exhibition" alt="" :src='detail.userPublishLinkVos[0].coverUrl'>
      </div> -->

			<div class="image-wrapper_2 flex-row" v-if="detail.type == 'PEOPLE_HOMEPAGE'">
				<img class="image_people" alt="" :src="detail.userPublishLinkVos[0].coverUrl" />
			</div>

			<div class="image-wrapper_3 flex-row" v-if="detail.type == 'ENTERPRISES'">
				<img class="image_people" alt="" :src="detail.userPublishLinkVos[0].coverUrl" />
			</div>
			<div class="image-wrapper_3 flex-row" v-if="detail.type == 'NEWS'">
				<img class="image_people" alt="" :src="detail.userPublishLinkVos[0].coverUrl" />
			</div>

			<div class="image-wrapper_for flex-row" v-if="detail.type == 'FORWARDING'">
				<img class="img_forwarding" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/forwarding.jpg" alt="" />
			</div>
		</div>

		<div class="box_5 flex-col" v-if="detail.type == 'TEXT'">
			<div class="block_1 flex-row">
				<img class="label_2" referrerpolicy="no-referrer" :src="detail.avatar" />
				<div class="text-wrapper_3 flex-col justify-between">
					<div class="text_2">{{ detail.contactName }}</div>
					<div class="text_3 text-ellipsis-2">{{ detail.company }}·{{ detail.position }}</div>
				</div>
			</div>
			<div class="text_5">
				<div class="inline-important">
					<div class="inline-important topic" @click.stop="handelTopic()" v-if="detail.topicName">#{{ detail.topicName }}</div>
					{{ detail.content }}
				</div>
				<div v-if="detail.userPublishForwardingVo && detail.userPublishForwardingVo.userPublishForwardingRefVoList.length > 1" class="inline-important">
					<div class="inline-important" v-for="(item, index) in detail.userPublishForwardingVo.userPublishForwardingRefVoList">
						<div class="inline-important" :key="index" v-if="index != 0">
							//
							<div class="inline-important contactName" @click.stop="handelUserMainPage(item)">@{{ item.contactName }}</div>
							:
							<div class="inline-important topic" v-if="item.topicName" @click.stop="handelTopic(item)">#{{ item.topicName }}</div>
							<div class="inline-important content">{{ item.content }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 单独展会类型 -->
		<div class="box_4 flex-col" v-if="detail.type == 'EXHIBITION' || detail.type == 'HOLD_MEETING'">
			<div class="singleExhibition flex-row" v-if="detail.type == 'EXHIBITION'">
				<div class="content">
					<div class="singleText text-ellipsis-1">
						<div class="inline-important">
							<div class="inline-important topic" @click.stop="handelTopic()" v-if="detail.topicName">#{{ detail.topicName }}</div>
							{{ detail.content }}
						</div>
						<div
							v-if="detail.userPublishForwardingVo && detail.userPublishForwardingVo.userPublishForwardingRefVoList.length > 1"
							class="inline-important text-ellipsis-1"
						>
							<div class="inline-important" v-for="(item, index) in detail.userPublishForwardingVo.userPublishForwardingRefVoList">
								<div class="inline-important" :key="index" v-if="index != 0">
									//
									<div class="inline-important contactName" @click.stop="handelUserMainPage(item)">@{{ item.contactName }}</div>
									:
									<div class="inline-important topic" v-if="item.topicName" @click.stop="handelTopic(item)">#{{ item.topicName }}</div>
									<div class="inline-important content">{{ item.content }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<img class="singleImg" alt="" :src="detail.userPublishLinkVos[0].coverUrl" />
			</div>

			<div class="singleExhibition flex-row" v-if="detail.type == 'HOLD_MEETING'">
				<div class="content">
					<div class="singleText text-ellipsis-1">
						<div class="inline-important">
							<div class="inline-important topic" @click.stop="handelTopic()" v-if="detail.topicName">#{{ detail.topicName }}</div>
							{{ detail.content }}
						</div>
						<div
							v-if="detail.userPublishForwardingVo && detail.userPublishForwardingVo.userPublishForwardingRefVoList.length > 1"
							class="inline-important text-ellipsis-1"
						>
							<div class="inline-important" v-for="(item, index) in detail.userPublishForwardingVo.userPublishForwardingRefVoList">
								<div class="inline-important" :key="index" v-if="index != 0">
									//
									<div class="inline-important contactName" @click.stop="handelUserMainPage(item)">@{{ item.contactName }}</div>
									:
									<div class="inline-important topic" v-if="item.topicName" @click.stop="handelTopic(item)">#{{ item.topicName }}</div>
									<div class="inline-important content">{{ item.content }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<img class="singleImg" alt="" :src="detail.userPublishLinkVos[0].coverUrl" />
			</div>
		</div>

		<div id="DONE" v-if="complete"></div>
	</div>
</template>

<script>
import { GetQueryString, loadImageEnd } from '@/utils/utils';
import { getTrendDetail } from '../../api/posterApi';
export default {
	name: 'trendposter',

	data() {
		return {
			token: '',
			appKey: '',
			eventKey: '',
			id: '',
			detail: {},
			complete: false
		};
	},

	created() {
		this.token = decodeURIComponent(GetQueryString('token'));
		this.appKey = decodeURIComponent(GetQueryString('appKey'));
		this.eventKey = decodeURIComponent(GetQueryString('eventKey'));
		this.id = decodeURIComponent(GetQueryString('id'));
		this.getInfo();
		// 198
	},

	methods: {
		handleImg(arr) {
			let picList = [];
			arr.forEach((v) => {
				picList.push(v.previewUrl);
			});
			return picList;
		},
		getInfo() {
			var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey };
			let headers = {
				'x-call-client-info': JSON.stringify(headerClientInfo),
				Authorization: this.token
			};
			getTrendDetail(headers, this.id).then((res) => {
				console.log(res);
				this.detail = res.data;
				if (this.detail.type == 'PICTURE') {
					if (this.detail.userPublishAttachmentVos.length > 3) {
						this.detail.pictureLength = this.detail.userPublishAttachmentVos.length;
						this.detail.userPublishAttachmentVos = this.detail.userPublishAttachmentVos.splice(0, 3);
					}
					let allImg = this.handleImg(this.detail.userPublishAttachmentVos);
					loadImageEnd(allImg, () => {
						console.log('图片加载完毕');
						this.complete = true;
					});
				}

				if (
					this.detail.type == 'EXHIBITION' ||
					this.detail.type == 'HOLD_MEETING' ||
					this.detail.type == 'PEOPLE_HOMEPAGE' ||
					this.detail.type == 'ENTERPRISES' ||
					this.detail.type == 'NEWS'
				) {
					let allImg = [this.detail.userPublishLinkVos[0].coverUrl];
					loadImageEnd(allImg, () => {
						console.log('图片加载完毕');
						this.complete = true;
					});
				}

				if (this.detail.type == 'TEXT') {
					this.complete = true;
				}

				if (this.detail.type == 'FORWARDING') {
					let allImg = ['https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/image/forwarding.jpg'];
					loadImageEnd(allImg, () => {
						console.log('图片加载完毕');
						this.complete = true;
					});
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
.singleExhibition {
	width: 420px;
	height: 336px;
	position: relative;
	.singleImg {
		width: 100%;
		height: calc(100% - 54px);
		border-radius: 10px;
	}
	.content {
		width: 100%;
		height: 54px;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
		position: absolute;
		bottom: 0;
		.singleText {
			font-size: 24px;
			text-align: left;
			line-height: 54px;
			padding: 0 12px;
		}
	}
}

.inline-important {
	display: inline !important;
	font-size: 24px;
}

.content {
	color: #262626;
}

.topic {
	color: #7691b8;
	margin-right: 6rpx;
}

.contactName {
	display: inline !important;
	color: #7691b8;
}
.box_4 {
	background-color: rgba(255, 255, 255, 1);
	width: 420px;
	height: 336px;
}
.box_5 {
	background: #d4e2d9;
	width: 420px;
	height: 336px;
}

.block_1 {
	width: 159px;
	// height: 34px;
	margin: 16px 0 0 16px;
}

.label_2 {
	width: 50px;
	height: 50px;
	border-radius: 50%;
}

.text-wrapper_3 {
	width: 300px;
	min-height: 33px;
	margin-left: 9px;
}

.text_2 {
	overflow-wrap: break-word;
	color: rgba(38, 38, 38, 1);
	font-size: 24px;
	font-family: PingFang SC-Medium;
	font-weight: 500;
	text-align: left;
	white-space: nowrap;
}

.text_3 {
	overflow-wrap: break-word;
	color: rgba(153, 153, 153, 1);
	font-size: 16px;
	font-family: PingFang SC-Regular;
	text-align: left;
	white-space: nowrap;
	// margin-top: 10px;
}

.block_2 {
	background-color: rgba(153, 153, 153, 1);
	border-radius: 50%;
	width: 2px;
	height: 2px;
	margin: 24px 0 0 4px;
}

.text_4 {
	width: 48px;
	height: 14px;
	overflow-wrap: break-word;
	color: rgba(153, 153, 153, 1);
	font-size: 9px;
	font-family: PingFang SC-Regular;
	font-weight: NaN;
	text-align: left;
	white-space: nowrap;
	line-height: 13px;
	margin: 19px 0 0 4px;
}

.text_5 {
	width: 388px;
	// height: 60px;
	overflow-wrap: break-word;
	word-break: break-all;
	color: rgba(38, 38, 38, 1);
	font-size: 14px;
	// font-family: PingFang SC-Regular;
	// font-weight: NaN;
	text-align: left;
	// line-height: 20px;
	margin: 9px 0 0 16px;
}

.image-wrapper_3 {
	width: 100%;
	height: 230px;
	margin: 10px 0 81px 16px;
	img {
		width: 100%;
		height: 100%;
	}
}

.image-wrapper_2 {
	width: 388px;
	height: 126px;
	margin: 10px 0 81px 16px;
}

.image-wrapper_for {
	width: 280px;
	height: 264px;
	background: #e9f0ec;
	border-radius: 9px;
	margin: 10px 0 81px 16px;
	filter: blur(6px);
	.img_forwarding {
		width: 280px;
		height: 264px;
		border-radius: 9px;
	}
}

.image_1-0 {
	width: 126px;
	height: 126px;
	margin-right: 5px;
	border-radius: 10px;
	object-fit: cover;
	.dialog {
		position: absolute;
		width: 126px;
		height: 126px;
		background: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		border-radius: 10px;
		text-align: center;
		line-height: 126px;
	}
}
.image_exhibition {
	width: 100%;
	height: 336px;
	border-radius: 10px;
	transform: scale(0.8);
	position: relative;
	top: -35px;
	left: -40px;
}
.image_people {
	width: 100%;
	height: 100px;
	border-radius: 10px;
}
.pictureBox {
	position: relative;
	.dialog {
		position: absolute;
		width: 126px;
		height: 126px;
		background: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		border-radius: 10px;
		text-align: center;
		line-height: 126px;
		color: #fff;
		font-size: 30px;
	}
}
</style>